import { appStorage } from "@miview/utils";

export const getToken = async () => {
  return appStorage.getItem("token");
};
